import { useLazyQuery } from '@apollo/client';
import type { MultipleDealsFetch } from '@openx/components-deal/lib/utils/context/DealHookTypes.ts';
import type { DealApi, DealOaApi } from '@openx/types/deal.ts';
import { useCallback, useState } from 'react';
import { GetDealDocument } from '../../../graphql/query/deals/GetDeal.generated.tsx';
import { formatDeal } from '../../../modules/deals/utils/formatDeal.ts';

export const useMultipleDealsFetch: MultipleDealsFetch = <T extends DealApi = DealOaApi>() => {
  const [getDeal] = useLazyQuery(GetDealDocument);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchDeals = useCallback(
    async (ids: string[]) => {
      setLoading(true);

      const promises = ids.map(id => {
        return getDeal({ variables: { id } });
      });

      try {
        const results = await Promise.all(promises);

        const deals = results.map(response => {
          if (!response.data?.dealById) {
            throw new Error('Missing deal data in response.');
          }
          return formatDeal(response.data?.dealById) as T;
        });

        return { deals };
      } catch (e) {
        return { error: e };
      } finally {
        setLoading(false);
      }
    },
    [getDeal]
  );

  return {
    fetchDeals,
    loading,
  };
};
